import React from 'react';
import { connect } from 'react-redux';
import { createToolbarEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconMessage } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { openChat, setFocusedTab } from '../../actions.web';
import { ChatTabs } from '../../constants';
import ChatCounter from './ChatCounter';
/**
 * Implementation of a button for accessing chat pane.
 */
class ChatButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.openChat';
    toggledAccessibilityLabel = 'toolbar.accessibilityLabel.closeChat';
    icon = IconMessage;
    label = 'toolbar.openChat';
    toggledLabel = 'toolbar.closeChat';
    tooltip = 'toolbar.openChat';
    toggledTooltip = 'toolbar.closeChat';
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._chatOpen;
    }
    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {boReact$Nodeolean}
     */
    render() {
        return (React.createElement("div", { className: 'toolbar-button-with-badge', key: 'chatcontainer' },
            super.render(),
            React.createElement(ChatCounter, null)));
    }
    /**
     * Handles clicking the button: always open chat and focus Chat tab.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        sendAnalytics(createToolbarEvent('open.chat'));
        dispatch(closeOverflowMenuIfOpen());
        dispatch(openChat());
        dispatch(setFocusedTab(ChatTabs.CHAT));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
        _chatOpen: state['features/chat'].isOpen
    };
};
export default translate(connect(mapStateToProps)(ChatButton));
